/** Shared app types. */

export interface VideoMeta {
  name: string
  mimeType: string
  bytes: number
  width: number
  height: number
  duration: number
  source: 'screen' | 'import' | 'sandbox'
  createdAt: number
}

export type ExportStatus = 'idle' | 'preparing' | 'rendering' | 'encoding' | 'done' | 'cancelled' | 'error'

export interface ExportState {
  status: ExportStatus
  progress: number
  message: string | null
  url: string | null
  filename: string | null
  bytes: number | null
  error: string | null
}

export const IDLE_EXPORT_STATE: ExportState = {
  status: 'idle',
  progress: 0,
  message: null,
  url: null,
  filename: null,
  bytes: null,
  error: null,
}

export type NoticeTone = 'info' | 'success' | 'warn' | 'error'

export interface Notice {
  id: string
  tone: NoticeTone
  text: string
}
